module.exports = __webpack_public_path__ + "media/images/entry/entry_btn2-b6318fc6fc912c804458e277e336a71b.gif";